module.exports = __webpack_public_path__ + "img/0pet3.137c3222.png";